import ManagePatientModal from '@/components/dashboard/liste-patients/manage-patient'
import store_patient from "@/store/mods/clinique/patients"

export default {
    name: 'liste-patients',
    components: {
        ManagePatientModal
    },
    props: [],
    data() {
        return {
            l_is_loading: true,
            l_is_empty: false,

            fields: [
                { key: 'patient_code', label: 'Numéro de dossier' }, 
                { key: 'patient_nom', label: 'Patient' }, 'sexe', { key: 'age', label: 'Âge' },  'patient_telephone', 'action.s'
            ],
            patient_filter: "",
            perPage: 400,
            currentPage: 1,

            patient_id: 0,
            liste_all_patients: [],
            toggler: 0,
        }
    },

    computed: {
        refresh() {
            return this.$store.getters.refresh
        }
    },

    watch: {
        refresh() {
            this.refreshListePatient()
        }
    },

    mounted() {
        this.refreshListePatient()
    },

    methods: {
        refreshListePatient() {
            this.l_is_loading = true

            store_patient.getListeAllPatient().then((patients) => {
                this.liste_all_patients = patients
                if (this.liste_all_patients.length > 0) {
                    this.l_is_empty = false
                } else {
                    this.l_is_empty = true
                }
                this.l_is_loading = false
            })
        },

        setPatientToEdit(patient_id) {
            this.patient_id = parseInt(patient_id),
            this.toggler = (this.toggler == 0)?1:0
        }
    }
}